import type { Caching } from "@/lib/caching"
import { cacheHasExpired } from "@/lib/caching/hasExpired"

export const cacheStillFresh = <DataType>(
  payload: Caching.Payload<DataType>,
  timestamp: Caching.Timestamp = Date.now()
) => {
  return !cacheHasExpired(payload, timestamp)
}
